import { createContentPropTypes } from '../../helpers/content';

const content = {
	title: 'About this payment',
	subTitle: 'Payment details',
	paymentStatusTitle: 'Payment status',
	batchTitle: 'View',
	statusLabel: 'Status',
	authRequiredLabel: 'Authorisation Required',
	howToSelfAuthoriseTitle: 'Using our mobile banking app',
	howToSelfAuthoriseBody:
		'Please review the details below, then log in to your mobile banking app to authorise this payment. It’s simple and secure – and it’ll help protect you from online fraud.',
	howToSelfAuthoriseBodyHardToken: 'To continue with this payment, you have to authorise it using your security token.',
	howToThirdPartyAuthorise:
		'This payment is awaiting authorisation by the user above using one of our online security methods. This user will have received a notification letting them know they had a payment to authorise when the payment was first submitted.',
	howToCAAuthorise:
		'This payment is awaiting authorisation using one of our online security methods. We’ve sent a notification to users who can approve this payment. If you wish to authorise this payment, please use your usual online security method.',
	howToThirdPartyAuthorisePlural:
		'This payment is awaiting authorisation by the users above using one of our online security methods. These users will have received a notification letting them know they had a payment to authorise when the payment was first submitted.',
	howtoAuthoriseGroupApprovals:
		'This payment is awaiting authorisation using one of our online security methods. We’ve sent a notification to users who can approve this payment.',
	back: 'Back',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
